import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './EduQuiz.css';
const cx = classNames.bind(styles);

class EduQuizFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { resetFilter, filterClose, cancelFilter, executeFilter, paramData, checkFilter, tempFilter } = this.props;

    // 퀴즈 유형 필터
    const quizType = [
      { 0: defineMessages(formatMessage({ id: 'Quiz_6', defaultMessage: '진위형' })) },
      { 1: defineMessages(formatMessage({ id: 'Quiz_7', defaultMessage: '선다형' })) }
    ];

    const quizFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'Quiz_1', defaultMessage: '퀴즈 유형' }))}
        />
        {quizType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, index) => {
                e.stopPropagation();
                checkFilter('quizTypeArray', index);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['quizTypeArray'] &&
                      tempFilter['quizTypeArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                    // 'checkmark box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let quizTypeArray = paramData.filter.quizTypeArray;

    if (quizTypeArray === undefined) {
      quizTypeArray = [];
    }

    const totalArrayLength = quizTypeArray.length;

    let quizTypeInfo = null;

    if (quizTypeArray.length > 0) {
      quizTypeInfo = (
        <div className={cx('tooltip-row')}>
          <div className={cx('tooltip-title')}>
            <span className={cx('title-dot')} />
            {defineMessages(formatMessage({ id: 'Quiz_1', defaultMessage: '퀴즈 유형' }))}
          </div>
          <span className={cx('tooltip-context')}>
            {quizTypeArray.map((value, index) => {
              const quizTypeArray = paramData.getIn(['filter', 'quizTypeArray']);

              let templateStatus = '';
              if (quizTypeArray[index] === '0') {
                templateStatus = defineMessages(formatMessage({ id: 'Quiz_6', defaultMessage: '진위형' }));
              } else if (quizTypeArray[index] === '1') {
                templateStatus = defineMessages(formatMessage({ id: 'Quiz_7', defaultMessage: '선다형' }));
              }

              const text =
                quizTypeArray[quizTypeArray.length - 1] !== quizTypeArray[index]
                  ? templateStatus + ','
                  : templateStatus;
              return (
                <span key={index} className={cx('context-value')}>
                  {text}
                </span>
              );
            })}
          </span>
        </div>
      );
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {quizTypeInfo}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
                <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            onClose={filterClose}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={1}>
              <Grid.Column textAlign="left">{quizFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options')}>
              <Grid.Column>
                <div className={cx('all-check-off')} onClick={resetFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={cancelFilter}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={executeFilter}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(EduQuizFilter);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduQuizFilter.js